<template>
  <component :is="layoutComponent" />
</template>

<script>
import secureStorage from '../controllers/secureStorage.js'
import HTTPRequest from '../controllers/httpRequest.js'

import AuthLayout from '@/layout/AuthLayout';
import TWAuthLayout from '@/layout/Tailwind/AuthLayout';

import { ft, gft } from '../../featureFlags.js';

export default {
  data() {
    return {
      layouts: {
        login: 'authLayout',
        password_reset: 'authLayout',
        password_change: 'authLayout',
        connections: 'authLayout'
      },
      components: {
        authLayout: {
          default: AuthLayout,
          tailwind: TWAuthLayout
        }
      }
    }
  },
  props: {
    feature_flag: {
      type: String,
      required: true
    },
    dependencies: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    layoutComponent() {
      const route_name = this.$route.name;
      const layout = this.layouts[route_name];
      const component = this.components[layout] || {};

      let ftEnabled = false;
      if (this.dependencies)
        ftEnabled = ft(this.feature_flag, [gft(route_name)]);
      else
        ftEnabled = ft(this.feature_flag);

      return ftEnabled ? component.tailwind : component.default;
    },
  },
  methods: {
    async checkSession(){
      if (window.location.pathname != '/')
        return true

      const response = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + secureStorage.getItem("userId"), null);
      if (
        secureStorage.getItem("loggedIn") == true &&
        secureStorage.getItem("autoLogin") == true &&
        !response.error
      )
        this.$router.push('/landing_page');
      else
        this.$router.push('/login');
    }
  },
  mounted(){
    this.checkSession()
  },
  mounted() {
    if (this.layoutComponent) 
      document.body.classList.add('tw-bg-gray-200');
  }
};
</script>
